import { useState } from "react";
import {
  PlansApi,
  RequestRegistPlanRequest,
  PlansRegisterPlansPostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiRegisterPlans = () => {
  const [resultRegister, setResultRegister] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const registerPlans = async (req: RequestRegistPlanRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: PlansRegisterPlansPostRequest = {
        req,
      };

      const api = new PlansApi(config);
      const response = await api.plansRegisterPlansPost(request);
      setResultRegister(response);
      return response;
    } catch (err) {
      setError("プランの登録に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { registerPlans, resultRegister, error, isLoading };
};
